export function netejaDescripcio(text) {
  if (!text) return ''

  // 1) Eliminar prefixos del tipus BM), RT), ET)
  const regex = /\b(BM|RT|ET)\)\s*(.*)/i
  const match = text.match(regex)
  let resultat = match ? match[2] : text

  // 2) Substituir tots els '_' per espai
  resultat = resultat.replace(/_/g, ' ')

  // 3) Netejar espais duplicats
  resultat = resultat.replace(/\s+/g, ' ')

  // 4) Treure espais de l'inici i del final
  return resultat.trim()
}



export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "long",
    year: "numeric"
  });
}


export function formatNumber(number) {
  if (!number && number !== 0) return '';
  return Number(number).toLocaleString('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  });
}

export function formatDateRange (startDateStr, endDateStr) {
    const start = new Date(startDateStr)
    const end = new Date(endDateStr)

    const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()
    const optionsDay = { day: 'numeric' }
    const optionsFull = { day: 'numeric', month: 'long' }
    const startFormatted = start.toLocaleDateString('es-ES', sameMonth ? optionsDay : optionsFull)
    const endFormatted = end.toLocaleDateString('es-ES', optionsFull)
    const year = end.getFullYear()

    return `Del ${startFormatted} al ${endFormatted} de ${year}`
}